import React from 'react';

function EmptyTodos(){
    return(
       <p>Crea tu primer Que Hacer</p>
    );
}

export { EmptyTodos };